import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, Organizations, UserState } from '@ra-state';
import {
  cancelFakeEntitlement,
  getOrganizations,
  getUserPreferences,
  setOrganizations,
  setUserId,
  setUserPreferences,
  updateSecondaryEmails,
} from './user.actions';
import {
  selectOrganizations,
  selectRefreshEntitlementGrid,
  selectSecondaryEmails,
  selectUserId,
  selectUserState,
} from './user.selectors';

@Injectable({
  providedIn: 'root',
})
export class UserFacade {
  private readonly store$ = inject<Store<AppState>>(Store);

  user$ = this.store$.select(selectUserState);
  secondaryEmails$ = this.store$.select(selectSecondaryEmails);

  organizations$ = this.store$.select(selectOrganizations);
  userId$ = this.store$.select(selectUserId);
  refreshEntitlementGrid$ = this.store$.select(selectRefreshEntitlementGrid);

  getUserPreferences(userId: string): void {
    this.store$.dispatch(getUserPreferences({ userId }));
  }

  setUserPreferences(userState: UserState): void {
    this.store$.dispatch(setUserPreferences({ userState }));
  }

  setSecondaryEmails(userId: string, secondaryEmails: string[]): void {
    this.store$.dispatch(updateSecondaryEmails({ userId, secondaryEmails }));
  }

  getOrganizations(userId: string): void {
    this.store$.dispatch(getOrganizations({ userId }));
  }

  setOrganizations(organizations: Organizations[]): void {
    this.store$.dispatch(setOrganizations({ organizations }));
  }

  setUserId(userId: string): void {
    this.store$.dispatch(setUserId({ userId }));
  }

  cancelFakeEntitlement(entitlementId: string): void {
    this.store$.dispatch(cancelFakeEntitlement({ entitlementId }));
  }
}
